import script from "./TransactionBulkPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionBulkPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionBulkPage.vue?vue&type=style&index=0&id=ef06c456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef06c456"]])

export default __exports__